<template>
  <b-row>
    <b-col md="4" class="mb-2">
      <b-card>
        <h5 class="mb-1">Tables</h5>
        <p v-if="connection" class="text-muted small mb-1">
          {{ connection.database }} on {{ connection.host }}
          <b-badge :variant="connection.connected ? 'success' : 'danger'">
            {{ connection.connected ? 'connected' : 'offline' }}
          </b-badge>
        </p>
        <b-form-input
          v-model="tableSearch"
          placeholder="Filter tables"
          class="mb-1"
        />
        <div class="table-list">
          <button
            v-for="table in filteredTables"
            :key="table.name"
            type="button"
            class="table-item"
            @click="selectTable(table.name)"
          >
            <span>{{ table.name }}</span>
            <small class="text-muted">{{ table.rows }}</small>
          </button>
          <p v-if="!loading && filteredTables.length === 0" class="text-muted mb-0">
            No tables found.
          </p>
        </div>
      </b-card>
    </b-col>
    <b-col md="8">
      <b-card>
        <h5 class="mb-1">SQL query</h5>
        <b-form-textarea
          v-model="sql"
          rows="6"
          placeholder="SELECT * FROM users LIMIT 20"
        />
        <b-button
          class="mt-1"
          variant="primary"
          :disabled="running || !sql.trim()"
          @click="runQuery"
        >
          {{ running ? 'Running…' : 'Run query' }}
        </b-button>
        <b-alert v-if="message" show class="mt-1" :variant="ok ? 'success' : 'danger'">
          {{ message }}
        </b-alert>
        <div v-if="columns.length" class="table-responsive mt-1">
          <table class="table table-sm">
            <thead>
              <tr>
                <th v-for="column in columns" :key="column">{{ column }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, index) in rows" :key="index">
                <td v-for="column in columns" :key="column">{{ formatCell(row[column]) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import {
  BAlert, BBadge, BButton, BCard, BCol, BFormInput, BFormTextarea, BRow,
} from 'bootstrap-vue'
import { adminPanelApi } from '@/services/adminPanelApi'

export default {
  components: {
    BAlert, BBadge, BButton, BCard, BCol, BFormInput, BFormTextarea, BRow,
  },
  data() {
    return {
      connection: null,
      tables: [],
      tableSearch: '',
      sql: '',
      columns: [],
      rows: [],
      message: '',
      ok: true,
      loading: false,
      running: false,
    }
  },
  computed: {
    filteredTables() {
      const term = this.tableSearch.trim().toLowerCase()
      if (!term) return this.tables
      return this.tables.filter(table => table.name.toLowerCase().includes(term))
    },
  },
  created() {
    this.loadInfo()
  },
  methods: {
    async loadInfo() {
      this.loading = true
      try {
        const res = await adminPanelApi.setupSqlInfo()
        this.connection = res.data?.data?.connection || null
        this.tables = res.data?.data?.tables || []
      } catch (error) {
        this.ok = false
        this.message = error?.response?.data?.message || 'Could not load tables.'
      } finally {
        this.loading = false
      }
    },
    selectTable(name) {
      this.sql = `SELECT * FROM \`${name}\` LIMIT 50`
    },
    async runQuery() {
      this.running = true
      this.message = ''
      this.columns = []
      this.rows = []
      try {
        const res = await adminPanelApi.setupSqlQuery(this.sql)
        const data = res.data?.data || {}
        this.ok = true
        this.columns = data.columns || []
        this.rows = data.rows || []
        this.message = data.message || `${data.row_count || 0} row(s).`
      } catch (error) {
        this.ok = false
        this.message = error?.response?.data?.message || 'Query failed.'
      } finally {
        this.running = false
      }
    },
    formatCell(value) {
      if (value === null || value === undefined) return ''
      if (typeof value === 'object') return JSON.stringify(value)
      return String(value)
    },
  },
}
</script>

<style scoped>
.table-list {
  max-height: 520px;
  overflow: auto;
}
.table-item {
  width: 100%;
  display: flex;
  justify-content: space-between;
  gap: 8px;
  border: 0;
  background: transparent;
  text-align: left;
  padding: 6px 4px;
  border-bottom: 1px solid #ebe9f1;
}
.table-item:hover {
  background: #f8f8f8;
}
</style>
